module.exports = __webpack_public_path__ + "img/gs.d0accf3a.png";